// extracted by mini-css-extract-plugin
export var active = "_ba-7";
export var container = "_ba-0";
export var evenWidth = "_ba-4";
export var large = "_ba-5";
export var outlet = "_ba-8";
export var slide = "_ba-2";
export var small = "_ba-6";
export var tab = "_ba-3";
export var tabs = "_ba-1";